import { URL_CONSTANTS } from "../config/appConstants";

export const AppRoutes = {
    LOGIN: '/login',
    VERIFY_EMAIL: '/',
    VERIFY_DOB: '/verify-dob',
    VERIFY_OTP: '/verify-otp',
    SET_PASSWORD: '/set-password',
    TERMS_CONDITIONS: '/terms-and-conditions',
    TIMELINE: '/timeline',
    HOME: '/home',
    OPTIONS: '/menu',
    PROFILE: '/profile',
    BASIC_PROFILE: '/profile/basic-profile',
    PARENTAL_PROFILE: '/profile/parental-profile',
    OBSERVATION_DETAILS_SCREEN: (id: string) => `/observations/${id}`,
    ADD_OBSERVATION: '/add-observation',
    EYENGAGE: '/eyengage',
    INVOICE: '/invoice',
    INVOICE_DETAILS: '/invoice/details',
    EYENGAGE_POST_DETAILS: '/eyengage/posts',
    PLANNING: '/home-learning/planning',
    RESOURCES_DOCUMENTS: '/home-learning/resources-and-documents',
    RESOURCES_URL: '/homelearning/resources-and-documents/url',
    ACCIDENT_SHEET_DETAILS_SCREEN: (id: string) => `/accident-sheet/${id}`,
    CREATE_UPDATE_MEDICINE_FORM: (id: string) => `/create-update-medicine-form/${id}`,
    MEDICINE_FORM_DETAILS: (id: string) => `/medicine-form-details/${id}`,
    BOOKINGS: '/bookings',
    EYMEMORIES: '/eymemories-app',
    DOCUMENT_VIEWER: '/document-viewer',
    TRANSITION_REPORT_DETAILS: '/transition-report-details',
    SUMMATIVE_REPORT_DETAILS: '/summative-report-details',
    CUSTOM_TRANSITION_REPORT: '/custom-transition-report-details',
    CUSTOM_SUMMATIVE_REPORT: '/custom-summative-report-details',
    NOTIFICATIONS: '/notifications',
    MOBILE_APP: '/mobile-app',
    UNSUBSCRIBE_EMAILS: '/unsubscribe-emails',
    NOTIFICATIONS_SETTINGS: '/notifications-settings',
    COMMUNICATIONS: '/messages/communications',
    CONVERSATIONS: '/messages/conversations',
    EYLOG_MESSAGES: '/messages/eylog-messages',
    REPLY: '/reply',
    DAILY_DIARY_SCREEN: '/daily-diary',
    DAILY_DIARY_DETAILS_SCREEN: (date: string) => `/daily-diary?${URL_CONSTANTS.DATE}=${date}`,
    DEEP_LINK: '/deep-link/:token',
    MOBILE_APP_LANDSCAPE_VIEW: '/download-app',
    LEARNING_JOURNEY_PRINT: '/learning-journey/print'
};

export const EymemoryRoutes = {
    EYMEMORIES_ERROR: '/eymemories/error',
    EYMEMORIES_FORBIDDEN: '/eymemories/forbidden',
    EYMEMORIES_DOWNLOAD_LINK: '/eymemories/download-link',
    EYMEMORIES_DOWNLOAD_FROM_LINK: '/eymemories/download',
    VALIDATE_EYMEMORIES_DOWNLOAD_LINK: '/eymemories/download-link/:orderHash',
}

export const EymemoryRoutesList = [ 
    EymemoryRoutes.VALIDATE_EYMEMORIES_DOWNLOAD_LINK,
    `${EymemoryRoutes.EYMEMORIES_DOWNLOAD_FROM_LINK}/:orderHash`,
];

export const PublicRoutesList = [
    EymemoryRoutes.EYMEMORIES_ERROR,
    EymemoryRoutes.EYMEMORIES_FORBIDDEN,
    EymemoryRoutes.VALIDATE_EYMEMORIES_DOWNLOAD_LINK
];
